import {FilterDropdownProps} from "antd/es/table/interface";
import {Button, Input, Space} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {Key} from "react";

export const getColumnSearchProps = <T extends object>(dataIndex: keyof T) => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}: FilterDropdownProps) => (
        <div style={{padding: 8}}>
            <Input
                placeholder={`Search ${String(dataIndex)}`}
                value={selectedKeys[0]}
                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => confirm()}
                style={{marginBottom: 8, display: 'block'}}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => confirm()}
                    icon={<SearchOutlined/>}
                    size="small"
                    style={{width: 90}}
                >
                    Szukaj
                </Button>
                <Button
                    onClick={() => {
                        if (clearFilters) {
                            clearFilters();
                            confirm();
                        }
                        setSelectedKeys([]);
                    }}
                    size="small"
                    style={{width: 90}}
                >
                    Wyczyść
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered: boolean) => <SearchOutlined style={{color: filtered ? '#1890ff' : undefined}}/>,
    onFilter: (value: boolean | Key, record: T) => {
        const itemValue = record[dataIndex] as any;
        return (typeof itemValue === 'string' && typeof value === 'string' && itemValue.toLowerCase().includes(value.toLowerCase())) ||
            (typeof itemValue === 'number' && typeof value === 'number' && itemValue === value) ||
            (typeof itemValue === 'boolean' && typeof value === 'boolean' && itemValue === value);
    }
});